/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ deltaText: NonNullable<unknown> }} Workout_Highlights_Plan_Day_Delta_KgInputs */

const en_us2_workout_highlights_plan_day_delta_kg = /** @type {(inputs: Workout_Highlights_Plan_Day_Delta_KgInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText}`)
};

const pt_br2_workout_highlights_plan_day_delta_kg = /** @type {(inputs: Workout_Highlights_Plan_Day_Delta_KgInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText}`)
};

const es_419_workout_highlights_plan_day_delta_kg = /** @type {(inputs: Workout_Highlights_Plan_Day_Delta_KgInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText}`)
};

const pt_pt2_workout_highlights_plan_day_delta_kg = /** @type {(inputs: Workout_Highlights_Plan_Day_Delta_KgInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText}`)
};

const fr_fr2_workout_highlights_plan_day_delta_kg = /** @type {(inputs: Workout_Highlights_Plan_Day_Delta_KgInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText}`)
};

const de_de2_workout_highlights_plan_day_delta_kg = /** @type {(inputs: Workout_Highlights_Plan_Day_Delta_KgInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText}`)
};

const it_it2_workout_highlights_plan_day_delta_kg = /** @type {(inputs: Workout_Highlights_Plan_Day_Delta_KgInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText}`)
};

/**
* | output |
* | --- |
* | "{deltaText}" |
*
* @param {Workout_Highlights_Plan_Day_Delta_KgInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_highlights_plan_day_delta_kg = /** @type {((inputs: Workout_Highlights_Plan_Day_Delta_KgInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Highlights_Plan_Day_Delta_KgInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_highlights_plan_day_delta_kg(inputs)
	if (locale === "es-419") return es_419_workout_highlights_plan_day_delta_kg(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_highlights_plan_day_delta_kg(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_highlights_plan_day_delta_kg(inputs)
	if (locale === "de-DE") return de_de2_workout_highlights_plan_day_delta_kg(inputs)
	if (locale === "it-IT") return it_it2_workout_highlights_plan_day_delta_kg(inputs)
	return en_us2_workout_highlights_plan_day_delta_kg(inputs)
});
export { workout_highlights_plan_day_delta_kg as "workout-highlights.plan_day_delta_kg" }